export const MIN_DISTANCE = 5;
export const ARROW_POSITION = -16;
export const ARROW_SIZE = 24;
